import { FeaturesPaths, RootRoutePaths } from "./routes-constants";
import { CustomDropdownOption } from "../modules/shared/Models/shared-data-models.model";

export class Constants {
    static readonly MAX_CONVERSATION_LENGTH = 5000;
    static readonly CountryIds = {
        INDIA: 98,
        USA: 5,
    };
    static readonly Task = class {
        static readonly MIN_TASK_NUMBER_VALUE = 999;
        static readonly MIN_TASK_NUMBER_LENGTH = 4;
        static readonly ALLOWED_ROLES_FOR_PERFORMANCE_NOTES = [10, 11, 12, 14, 15];
    };
    static readonly TaskTypes = class {
        static readonly DEFAULT_TASK = 1;
        static readonly PARENT_TASK = 2;
        static readonly SUB_TASK = 3;
        static readonly BUG = 4;
        static readonly PERSONAL_TASK = 8;
    };
    static readonly TaskAttachment = class {
        static readonly DEFAULT_MAX_FILES = 10;
        static readonly DEFAULT_MAX_FILES_EXCEED_MESSAGE = "Maximum 10 files can be uploaded";
        static readonly SuccessMessages = class {
            static readonly ALL_FILES_DELETED = "All files deleted successfully";
            static readonly FILE_DOWNLOADED = "File downloaded successfully";
            static readonly FILE_DELETED = "File deleted successfully";
        };
        static readonly ErrorMessages = class {
            static readonly ALL_FILES_DELETE_ERROR = "Error while deleting all files";
            static readonly FILE_DOWNLOAD_ERROR = "Error while downloading file";
            static readonly FILE_DELETE_ERROR = "Error while deleting file";
            static readonly ATTACHMENT_NOT_FOUND = "File attachment could not be found";
        };
    };
    static readonly TaskStatus = class {
        static readonly SelectedCompleted = class {
            static readonly COMPLETED = "COMPLETED";
            static readonly LATE_COMPLETION = "LATE_COMPLETION";
            static readonly COMPLETED_ON_TIME = "COMPLETED";
        };
        static readonly CompleteOptions = class {
            static readonly COMPLETED_ON_TIME = "COMPLETED";
            static readonly LATE_COMPLETION = "LATE_COMPLETION";
            static readonly BOTH = "BOTH";
        };
    };
    static readonly WorkFlowType = class {
        static readonly PERSONAL_WORK_ITEM = 1;
        static readonly TEAM_WORK_ITEM = 3;
    };
    static readonly WorkflowTaskStatusIds = class {
        static readonly TEAM_WORKFLOW_STATUS_STARTED = 17;
        static readonly TEAM_WORKFLOW_STATUS_COMPLETED = 20;
    };
    static WorkflowTaskStatusNamesLowerCase = class {
        static readonly BACKLOG = "backlog";
        static readonly NOT_STARTED = "not-started";
        static readonly COMPLETED = "completed";
        static readonly STARTED = "started";
        static readonly ON_HOLD = "on-hold";
        static readonly BLOCKED = "blocked";
        static readonly DELETED = "deleted";
        static readonly DUE_DATE_NOT_PROVIDED = "Due Date Not Provided";
    };
    static ProgressSystemStatus = class {
        static readonly DELAYED = "DELAYED";
        static readonly WATCHLIST = "WATCHLIST";
        static readonly ONTRACK = "ONTRACK";
        static readonly NOTSTARTED = "NOTSTARTED";
        static readonly COMPLETED = "COMPLETED";
        static readonly LATE_COMPLETION = "LATE_COMPLETION";
    };
    static WorkflowTaskStatusNames = class {
        static readonly BACKLOG = "Backlog";
        static readonly NOT_STARTED = "Not-Started";
        static readonly COMPLETED = "Completed";
        static readonly STARTED = "Started";
        static readonly ON_HOLD = "On-Hold";
        static readonly BLOCKED = "Blocked";
        static readonly DELETED = "Deleted";
        static readonly DUE_DATE_NOT_PROVIDED = "Due Date Not Provided";
    };

    static WorkflowTaskStatusNamesLowerCaseForAI = class {
        static readonly BACKLOG = "backlog";
        static readonly NOT_STARTED = "not-started";
        static readonly COMPLETED = "complete";
        static readonly STARTED = "started";
        static readonly ON_HOLD = "on-hold";
        static readonly BLOCKED = "blocked";
        static readonly DELETED = "deleted";
        static readonly DUE_DATE_NOT_PROVIDED = "Due Date Not Provided";
    };
    public static readonly PROGRESS_SYSTEM_FOR_AI: CustomDropdownOption[] = [
        { value: "DELAYED", label: "Delayed" },
        { value: "WATCHLIST", label: "Watchlist" },
        { value: "ONTRACK", label: "On-Track" },
        { value: "NOTSTARTED", label: "Not-Started" },
        { value: "COMPLETED", label: "Completed" },
    ];

    static readonly PERSONAL_ORGANIZATION_NAME = "Personal";

    static Roles = class {
        static readonly BACKUP_ORG_ADMIN_ROLE_ID: number = 131;
        static readonly ORG_ADMIN_ROLE_ID: number = 132;
        static readonly PROJECT_ADMIN: number = 112;
        static readonly PROJECT_BACKUP_ADMIN: number = 111;
        static readonly TEAM_ADMIN_ROLE_ID: number = 102;
        static readonly TEAM_BACKUP_ADMIN_ROLE_ID: number = 101;
        static readonly SUPER_ADMIN_ROLE_ID: number = 900;
    };

    static readonly ORG_ADMIN_LEVEL_ROLES = [
        Constants.Roles.ORG_ADMIN_ROLE_ID,
        Constants.Roles.BACKUP_ORG_ADMIN_ROLE_ID,
    ];

    static readonly PROJECT_ADMIN_LEVEL_ROLES = [Constants.Roles.PROJECT_ADMIN, Constants.Roles.PROJECT_BACKUP_ADMIN];

    static ActionId = class {
        static readonly TASK_BASIC_UPDATE = 1;
        static readonly TEAM_TASK_VIEW = 2;
        static readonly TASK_ESSENTIAL_UPDATE = 3;
        static readonly ALL_TASK_BASIC_UPDATE = 4;
        static readonly ALL_TASK_ESSENTIAL_UPDATE = 5;
    };
    static EntityTypes = class {
        static readonly USER: number = 1;
        static readonly ORG: number = 2;
        static readonly BU: number = 3;
        static readonly PROJECT: number = 4;
        static readonly TEAM: number = 5;
        static readonly TASK: number = 6;
        static readonly MEETING: number = 7;
        static readonly LEAVE: number = 8;
        static readonly ORGANIZATION_HOLIDAY: number = 9;
        static readonly OVERTIME: number = 10;
        static readonly PERSONAL_ORG_ID: number = 0;
        static readonly PERSONAL_TEAM_ID: number = 0;
    };
    static EntityTypesName = class {
        static readonly ORGANIZATION = "organization";
        static readonly BU = "bu";
        static readonly PROJECT = "project";
        static readonly TEAM = "team";
    };
    static EntityTypeTreeColours = class {
        static readonly ORG_COLOUR = "#275CB2"
        static readonly BU_COLOUR = "#56BA6F"
        static readonly PROJECT_COLOUR = "#F69145"
        static readonly TEAM_COLOUR = "#1D1D1F"
    }
    static WebSockets = class {
        static readonly USER_SUBSCRIBE_BROKER = "/ws-user/";
        static readonly USER_SUBSCRIBE_MESSAGE_DESTINATION = "/greetings";
    };
    static PageNumberForComments = class {
        static readonly Min_PAGE_NUM = 1;
        static readonly MAX_PAGE_NUM = 2;
        static readonly PAGE_SIZE = 50;
    };
    static readonly StatsRequestConstants = class {
        static readonly FROM_DATE_TIME = "00:00:00";
        static readonly TO_DATE_TIME = "23:59:59";
        static readonly NO_OF_DAYS = 30;
        static readonly DEFAULT_FROM_DATE_DAYS = 7;
        static readonly DEFAULT_TO_DATE_DAYS = 7;
    };
    static readonly FallBackDateTime = class {
        static readonly EXP_END_TIME_OF_PRESENT_DAY = "19:00:00";
    }
    static readonly PriorityConstants = class {
        static readonly PRIORITY_P0 = "P0 - Extremely Critical";
        static readonly PRIORITY_P1 = "P1 - Critical";
        static readonly PRIORITY_P2 = "P2 - Normal Importance";
        static readonly PRIORITY_P3 = "P3 - Almost Normal Importance";
        static readonly PRIORITY_P4 = "P4 - Low Priority";
    };
    // These constants are used in the code to pass the error message to the user
    static readonly ErrorMessages = class {
        static readonly SPRINT_EXPECTED_END_DATE_SHOULD_BE_GREATER =
            "Sprint Expected End Date should be greater than Expected Start Date";
        static readonly SPRINT_CAPACITY_ADJUSTMENT_DEADLINE_SHOULD_BE_IN_BETWEEN_START_END_DATE =
            "Sprint Capacity Adjustment deadline should belong to the range of expected start and end date.";
        static readonly NOT_REGISTERED_IN_PERSONAL_ACCOUNT_MESSAGE =
            "Register in personal organization to create a Work Item";
        static readonly NOT_REGISTERED_IN_PERSONAL_ACCOUNT_TITLE = "Not Personal Organization Found !!!";
        static readonly TEXTAREA_LENGTH_EXCEEDED_SUFFIX = "characters are allowed";

        static readonly FILE_SIZE_MUST_BE_LESS_THEN_40MB = "File size should be less than 40 MB";
        static readonly VIDEO_MUST_BE_LESS_THEN_10MB = "Video file size should be less than 10 MB";
        static readonly FILE_MUST_BE_LESS_THEN_5MB = "File size should be less than 5 MB";
        static readonly MAX_10_FILES_ALLOWED = "Maximum 10 files are allowed";
        static readonly UNSUPPORTED_FILE_TYPE = "Unsupported file type";
        static readonly MAX_5_FILES_ALLOWED = "Maximum 5 files are allowed";
        static readonly FILE_ALREADY_EXISTS = "File already exists";

        /** These are the general or common error messages we display on multiple pages*/
        static readonly ACCESS_CHANGED_MESSAGE = "Your access has changed and you have to login again.";
        static readonly SESSION_EXPIRED = "Your session has expired. Please login again.";
        static readonly SELECT_TASK_ASSIGNED_TO = "Select the assignee for started work Item";
        static readonly RECORD_MESSAGE_FIRST = "Please record a message First";
        static readonly PROVIDE_TASK_PRIORITY = "Please provide Work Item Priority";

        static readonly SELECT_ACTUAL_START_DATE = "Please select Work Item Actual Start Date";

        static readonly PROVIDE_ACTUAL_BOTH_START_DATETIME =
            "Please provide both Actual Start Date and Actual Start Time";
        static readonly PROVIDE_ACTUAL_BOTH_END_DATETIME = "Please provide both Actual End Date and Actual End Time";
        static readonly PROVIDE_EXPECTED_START_DATE = "Provide Work Item Expected Start Date";
        static readonly PROVIDE_EXPECTED_BOTH_START_DATETIME =
            "Please provide both Expected Start Date and Expected Start Time";
        static readonly PROVIDE_EXPECTED_BOTH_END_DATETIME =
            "Please provide both Expected End Date and Expected End Time";
        static readonly PROVIDE_EXPECTED_END_DATE = "Please provide Work Item Expected End Date";
        static readonly PROVIDE_TASK_TITLE = "Title cannot be blank";
        static readonly TASK_TITLE_LENGTH = "Title length should be in between 3 to 70 characters";
        static readonly PROVIDE_TASK_DESCRIPTION = "Description cannot be blank.";
        static readonly TASK_DESCRIPTION_LENGTH = "Description length should be in between 3 to 5000 characters";
        static readonly PROVIDE_FK_ACCOUNT_ID = "fkAccountId of user has not been set!";
        static readonly SELECT_TASK_WORKFLOW = "Please select Work Item Work Flow";
        static readonly SELECT_WORKFLOW_STATUS = "Please select Work Item Status";
        static readonly SELECT_CURRENT_ACTIVITY_INDICATOR = "Please select currentActivityIndicator";
        static readonly SELECT_ORGANIZATION = "Please select your organization";
        static readonly SELECT_TEAM = "Please select your team";
        static readonly STARTED_TASK_CANNOT_BE_CHANGED_TO_NOT_STARTED =
            "Started Work Item cannot be changed to not started";
        static readonly ACTUAL_START_DATE_GREATER_THAN_CURRENT_DATE =
            "Actual Start Date & Time cannot be greater than current date & time ";

        /** These are the error messages we display specifically on the Update Task page*/
        static readonly WorkItemValidationMessages = class {
            static readonly WORK_ITEM_EXPECTED_END_DATE_SHOULD_BE_GREATER_THAN_START_DATE =
                "Work item expected start date time cannot be greater than or equal to expected end date time";
            static readonly WORK_ITEM_ACTUAL_END_DATE_SHOULD_BE_GREATER_THAN_START_DATE =
                "Work item actual start date time cannot be greater than or equal to actual end date time";
            static readonly WORK_ITEM_ACTUAL_START_DATE_SHOULD_BE_LESS_THAN_CURRENT_DATE =
                "Work item actual start date time cannot be greater than current date time";
            static readonly WORK_ITEM_ACTUAL_END_DATE_SHOULD_BE_LESS_THAN_CURRENT_DATE =
                "Work item actual end date time cannot be greater than current date time";
            static readonly WORK_ITEM_ACTUAL_START_DATE_PRESENT_BUT_ASSIGNED_TO_USER_NOT_PRESENT: string =
                "Work item can't have actual start date time if assigned to user is not present";
            static readonly WORK_ITEM_ACTUAL_END_DATE_PRESENT_BUT_ASSIGNED_TO_USER_NOT_PRESENT: string =
                "Work item can't have actual end date time if assigned to user is not present";
        };
        static readonly UpdateTaskStatusValidation = class {
            static readonly CURRENTLY_SCHEDULED_INDICATOR_CANNOT_TRUE =
                "Currently Scheduled Indicator can't be TRUE for backlog Work Item";
            static readonly TASK_PRIORITY_EMPTY = "Please select Work Item Priority";
            static readonly UPDATE_PERCEIVED_PERCENTAGE =
                "Seems You have added New Effort but not updated the Work Item perceived % completed. Please update the Work Item perceived % completed";
            static readonly RECORD_EFFORT_FOR_TASK_PERCEIVED_DATE =
                "Record new effort before updating Work Item State.";
            static readonly PERCEIVED_PERCENTAGE_MARKED_AUTOMATICALLY_100 = "Perceived Percentage is marked 100%";
            static readonly RECORD_EFFORT_HUNDRED_PERCENT = "Please change Precevied Percentage to 100%";
            static readonly TASK_EXPECTED_END_DATE_REQUIRED = "Please Select Work Item Expected End Date and Time";
            static readonly UPDATE_TASK_ERROR = "Update Work Item Form Validation Fails";
            static readonly EXPECTED_START_AND_END_DATE_REQUIRED = "Expected Start and Expected End Dates are Required";
            static readonly UPDATE_WORKFLOW_STATUS_TO_COMPLETED = "Please, update workflow status to COMPLETED";
            static readonly ACTUAL_DATE_CAN_BE_TODAY_ONLY = "Actual End Date can only be today or less than today";
            static readonly ACTUAL_END_TIME_CANT_BE_MORE_THAN_TODAY =
                "Actual End Time can't be more than the current time";
            static readonly PERCEIVED_PERCENTAGE_EMPTY = "Please provide Work Item Perceived Percentage(%) Completed";
            static readonly NEW_EFFORT_EMPTY = "Please provide New Effort";
            static readonly ACTUAL_END_TIME_IS_UPDATED_TO_CURRENT_TIME = "Actual End Time is updated to current time";

            /** Error Messsages are used for add new effort and perceived percentage */
            static readonly EFFORT_DATE_REQUIRED = "Please provide effort date";
            static readonly EFFORT_REQUIRED = "Please Enter Some value of Hours/Minutes";
            static readonly SELECT_EFFORT_HOURS = "Please select effort hours b/w 0 to 24";
            static readonly SELECT_EFFORT_MINUTES = "Please select effort minutes b/w 0 to 60";
            static readonly TOTAL_EFFORTS_TIME = "Total effort time cannot be greater than 24 hours"
            static readonly RECORDED_EFFORT_DATE_EXISTS = "Recorded effort date already exists";
            static readonly PRIORITY_P0_AND_P1_ARE_NOT_ALLOWED_IN_BACKLOG = "P0 and P1 are not allowed in Backlog";
        };
        /** These are the error messages we display specifically on the Create Task page*/
        static readonly CreateTaskValidations = class {
            static readonly EXPECTED_DATES_ARE_IN_PAST_FROM_DUPLICATE_TASK =
                "Expected Dates from the duplicate Work Item are in past. Please review.";
            static readonly TASK_ESTIMATE_ZERO = "Work Item Estimate cannot be zero";
            static readonly PRIORITY_P0_P1_NOT_ALLOWED_IN_BACKLOG = "P0 and P1 are not allowed in Backlog";
            static readonly ADD_TASK_ERROR = "Add Work Item Form Validation Fails";
            static readonly PROVIDE_EXPECTED_END_DATE = "Please provide Work Item Expected End Date";
            static readonly PROVIDE_EXPECTED_END_TIME = "Please provide Work Item Expected End Time";
            static readonly PRIORITY_P4_NOT_ALLOWED = "Please change Priority. This Priority is not allowed";
            static readonly TASK_ESTIMATE_NOT_PROVIDED =
                "Input the estimate. In case you are not sure, put a ballpark estimate, which can be updated later and check the ballpark estimate checkbox.";
            static readonly EXPECTED_START_TIME_REQUIRED_IN_HIGH_PRIORITY_TASK =
                "Expected Start time is required in High Priority Work Item";
            static readonly EXPECTED_END_TIME_REQUIRED_IN_HIGH_PRIORITY_TASK =
                "Expected End time is required in High Priority Work Item";
            static readonly EXPECTED_END_DATE_SHOULD_BE_GREATER_THAN_START_DATE =
                "Expected End Date should be greater than Start Date";
        };
        /** These are the error messages we display specifically on the Login page*/
        static readonly LoginValidations = class {
            static readonly FIELDS_REQUIRED = "Fields cannot be empty or null";
        };
        static readonly VoiceInteractionValidations = class {
            static readonly CHOOSE_FILE = "Please select a file first";
        };
        static readonly FILE_NAME_MUST_BE_LESS_THEN_100_CHARACTERS = "File name must be less then 100 characters";
        static readonly TO_DATE_SHOULD_BE_GREATER_THAN_FROM_DATE = "To Date should be greater than From Date";
        static readonly NO_SELECTABLE_TEAM_FOUND: string = "No selectable team found";
        static readonly NO_SELECTABLE_PROJECT_FOUND: string = "No selectable project found";
        static readonly NO_SELECTABLE_ORGANIZATION_FOUND: string = "No selectable organization found";
        static readonly INVALID_DATE_RANGE: string = "Invalid date range. Please select a valid date range.";
        static readonly ESTIMATE_REQUIRED_FOR_COMPLETED_TASK: string = "Estimate is required for completed Work Items";

        static readonly Overtime = class {
            static readonly CREATED_SUCCESS = 'Overtime request created successfully.';
            static readonly CREATE_FAILED = 'Failed to create overtime request.';
            static readonly APPROVERS_LOAD_FAILED = 'Failed to load approvers.';
        };
    };
    static readonly InfoMessages = class {
        static readonly UPDATE_TASK_TO_SAVE_NOTES = "Don't Forget to update the Work Item to save notes changes";
        static readonly UPDATE_TASK_TO_SAVE_DELIVERABLES =
            "Don't Forget to update the Work Item to save deliverables changes";
        static readonly UPDATE_PERCEIVED_PERCENTAGE = "Please enter the Work Item perceived % completed";
        static readonly UPDATE_WORKFLOW_STATUS_TO_COMPLETED = "Please update workflow Work Item status to COMPLETED";
        static readonly ESTIMATE_SUGGESTION =
            "Input the estimate. In case you are not sure, put a ballpark estimate, which can be updated later and check the ballpark estimate checkbox.";
        static readonly ActualEndDate = class {
            static readonly TASK_ACTUAL_START_DATE = "'Please provide Actual Start Date Time'";
        };
        static VoiceInteracttionValidations = class {
            static readonly NAVIGATE_TO_TASK = "Navgating to create Work Item in 2 seconds...";
        };
        static readonly NAVIGATION_DOESNOT_EXIST = "No navigation exists!!";
        static readonly PARENT_TASK_WILL_MARKED_STARTED =
            "Parent task will be marked as started with this Work Item's actual start date & time";
        static readonly TASK_STATUS_MARKED_COMPLETED = "Work Item status is marked as completed";
        static readonly TASK_STATUS_MARKED_STARTED = "Work Item status is marked as started";
        static readonly PERCEIVED_PERCENTAGE_MARKED_100 = "Perceived Percentage Completed is marked 100%";
    };
    static readonly WarningMessages = class {
        static readonly TASK_ACTUAL_START_DATETIME = "Please select Work Item actual start date time.";
        static readonly TASK_EXPECTED_START_DATE_TIME_OR_CURRENT_DATE_WILL_TAKEN =
            "Please select Work Item expected start date time or Work Item actual start date time will be taken";
        static readonly SELECT_TASK_ACTUAL_START_DATE_OR_CURRENT_DATE_WILL_TAKEN =
            "Please select Work Item Actual Start Date & Time; otherwise, Current Date & Time will be used automatically.";
        static readonly SELECT_TASK_ACTUAL_END_DATE_OR_CURRENT_DATE_WILL_TAKEN =
            "Please select Work Item actual end date or current date will be taken";
        static readonly SELECT_TASK_EXPECTED_START_DATE_TIME_AND_TASK_ACTUAL_START_DATE_TIME =
            "Please select Work Item expected start date time and Work Item actual start date time.";
        static readonly SELECT_TASK_ACTUAL_END_TIME_OR_CURRENT_TIME_WILL =
            "Please select Work Item actual end time or current time will be taken";
        static readonly SELECT_TASK_ACTUAL_END_TIME_OR_OFFICE_END_TIME_WILL =
            "Please select Work Item actual end time or office end time will be taken";
        static readonly TASK_ACTUAL_END_DATE_CANNOT_BE_SET_MORE_THAN_CURRENT_DATE =
            "Work Item Actual End Date cannot be set more than the current date";
        static readonly PRIORITY_NOT_ALLOWED = "Please change Priority. This Priority is not allowed";
        static readonly NO_ROLE_TO_UPDATE_TASK_ESTIMATES: "No Role/Action to update the Work Item Estimates";

        static readonly ActualEndDate = class {
            static readonly TASK_ACTUAL_START_DATE = "'Remove Actual Start Date Time or change the workflow status";
        };
        static readonly OnDateChange = class {
            static readonly TO_DATE_ALERT = "To Date can't be less than the current date";
        };
        static readonly SELECT_DATE_OR_DATE_RANGE = "Please select a Date or Date Range";
        static readonly PROVIDE_BOTH_START_AND_END_DATE = "Please provide both the From and To dates.";
    };
    static readonly SuccessMessages = class {
        static readonly LoginValidations = class {
            static readonly OTP_SENT = "OTP sent to your registered email";
            static readonly CHECK_EMAIL = "Please check your email again.";
        };
        static readonly NavbarValidations = class {
            static readonly LOGOUT_SUCCESS = "Logged Out Successfully!!!";
        };
        static readonly RegistrationValidations = class {
            static readonly OTP_SENT = "Otp generated and sent successfully !";
            static readonly REGISTRATION_SUCCESS = "Registration Successful";
        };
        static readonly LeaveValidations = class {
            static readonly LEAVE_CANCELLED = "Leave has been successfully cancelled.";
            static readonly LEAVE_CANCELLATION_REQUEST = "Successfully sent the leave cancellation request.";
        };
        static readonly SPRINT_UPDATED_SUCCESSFULLY: string = "Sprint updated successfully";
        static readonly SPRINT_CREATED_SUCCESSFULLY: string = "Sprint created successfully";
        static readonly SPRINT_DELETED_AND_REMOVED_WORK_ITEMS_SUCCESSFULLY: string =
            "Deleted sprint successfully and removed Work Items successfully";
        static readonly SPRINT_DELETED_AND_DELETED_WORK_ITEMS_SUCCESSFULLY =
            "Deleted Sprint and Work Items successfully";
    };
    static readonly FileTypes = class {
        static readonly ALLOWED_FILE_TYPES =
            ".avi, .csv, .dot, .html, .mp3, .mp4, .mpeg, .rar, .zip, .jpg, .jpeg, .png, .gif, .bmp, .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .txt, .dwg, .dxf, .dng, .m4a, .webm, .pbix, .pbit, .pdids, .rdl, .json, .twb, .twbx, .heic, .xlsm";
    };
    static ERROR_FETCHING_TASK: string =
        "An unexpected error occurred! It seems like there is a problem at our end. Please contact system administrator at support@vijayi-wfh.com.";
    static SprintAdminAccessRoles: number[] = [15, 12]; // 15 is the role id for Project Admin
    static EpicModifyAccessRoles: number[] = [11, 12, 14, 15];
    static SprintRestrictedRoles: number[] = [102];
    static LeaveDetailsViewAccessRoles: number[] = [11, 12, 14, 15, 112, 131, 132];
    static FULL_DATE_DATE_FORMAT: string = "yyyy-MM-dd'T'HH:mm:ss";
    static TIME_FORMAT: string = "HH:mm:ss";
}

export class MapOfWorkflowStatus {
    // get the status codes for a particular workflow status
    static getWorkflowStatusCodes(workflowStatus: string, isTaskStarted: boolean = false) {
        return new Map([
            [Constants.WorkflowTaskStatusNames.BACKLOG, [0, 1, 2, 5, 6]],
            [Constants.WorkflowTaskStatusNames.NOT_STARTED, [1, 2, 3, 4, 5, 6]],
            [Constants.WorkflowTaskStatusNames.STARTED, [2, 3, 4, 5, 6]],
            [Constants.WorkflowTaskStatusNames.BLOCKED, isTaskStarted ? [3, 2, 4, 5, 6] : [3, 1, 2, 4, 5, 6]],
            [Constants.WorkflowTaskStatusNames.ON_HOLD, [4, 2, 3, 5, 6]],
            [Constants.WorkflowTaskStatusNames.COMPLETED, [5]],
            [Constants.WorkflowTaskStatusNames.DELETED, [6]],
        ]).get(workflowStatus);
    }
}

export class StickyNotesConstants {
    static readonly NOTE_ADDED = "Note added successfully";
    static readonly NOTE_UPDATED = "Note updated successfully";
    static readonly NOTE_DELETED = "Note deleted successfully";
    static readonly NOTE_NOT_FOUND = "Note not found";
    static readonly CANCLE_ADD_NOTE = "cancel";
    static NOTE_ADDED_TO_FAVOURITES: string = "Note added to favourites";
    static NOTE_REMOVED_FROM_FAVOURITES: string = "Note removed from favourites";
    static NOTE_PINNED_TO_TOP: string = "Note pinned to top";
    static NOTE_UNPINNED_FROM_TOP: string = "Note unpinned from top";
    static NOTE_PINNED_TO_DASHBOARD: string = "Note pinned to dashboard";
    static NOTE_UNPINNED_FROM_DASHBOARD: string = "Note unpinned from dashboard";
}

export class GlobalBroadCastConstants {
    static readonly PUSH_NOTIFICATION_CLICK = "push-notification-click";
}

export class GlobalConstants {
    static readonly EMPTY_STRING = "";
    static readonly SPACE = " ";
    static readonly COLON = ":";
    static readonly BREAKPOINTOBSERVER_MOBILE = "(max-width: 600px)";
    static readonly BREAKPOINTOBSERVER_TABLET = "(min-width: 768px) and (max-width: 1023px)";
    static readonly BREAKPOINTOBSERVER_DESKTOP = "(min-width: 1024px)";
}

export enum ProgressSystemBackgroundColors {
    NOTSTARTED = "#CCCCCC",
    ONTRACK = "#ADD8E6",
    COMPLETED = "#98FB98",
    LATE_COMPLETION = "#98FB98",
    WATCHLIST = "#FFFF99",
    DELAYED = "#F08080",
    OTHERS = "#CCCCCC",
}

export class FeatureModules {
    static readonly LeaveWorkflow = "LeaveWorkflow";
    static readonly GroupConversations = "GroupConversations";
    static readonly TimelineView = "TimeLine";
    static readonly MeetingsWorkflow = "MeetingsWorkflow";
    static readonly EditOrg = "EditOrg";
    static readonly JiraUpload = "JiraUpload";
}

export class FunctionalityNames {
    static readonly JitsiMeetRecordingAndAIAnalysis = "JitsiMeetRecordingAndAIAnalysis";
}

export const FeatureModulesAndPaths = [
    {
        featureName: FeatureModules.LeaveWorkflow,
        featurePath: RootRoutePaths.LEAVE_WORKFLOW,
    },
    {
        featureName: FeatureModules.GroupConversations,
        featurePath: FeaturesPaths.CONVERSATION,
    },
    {
        featureName: FeatureModules.TimelineView,
        featurePath: RootRoutePaths.TIMELINE_VIEW,
    },
    {
        featureName: FeatureModules.MeetingsWorkflow,
        featurePath: RootRoutePaths.MEETINGS_WORKFLOW,
    },
    {
        featureName: FeatureModules.EditOrg,
        featurePath: FeaturesPaths.MANAGE_ORGANIZATION,
    },
    {
        featureName: FeatureModules.JiraUpload,
        featurePath: RootRoutePaths.JIRA_UPLOAD,
    },
];

export const CUSTOM_DATE_TIME_FORMATS = {
    parse: {
        dateInput: "DD MMM YYYY, LT",
    },
    display: {
        dateInput: "DD MMM YYYY, LT",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
    },
};

export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: "DD MMM YYYY",
    },
    display: {
        dateInput: "DD MMM YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "DD MMM YYYY",
        monthYearA11yLabel: "MMMM YYYY",
    },
};

export const ICON_BTN_BG_COLOR = "#f9f9f9";
export const ICON_BTN_SIZE_SM = 16;
export const ICON_BTN_SIZE_MD = 24;
export const ICON_BTN_SIZE_LG = 32;

export const NAVBAR_TREE_HEIGHT_CONSTANTS = {
    Node_Height: 40,
    Start_Offset: 30
}

export const DEFAULT_TIME_PICKER_STATE = {
    HOUR: 12,
    MINUTE: 0,
    MERIDIAN: 'AM'
};